import { FovFieldTypes, FovGroupTypes, FovNodeTypes } from './fov-models';
import { FovBuilder } from './fov-builder';
export function isFovFilter(fov) {
    return fov.nodeType === FovNodeTypes.FILTER;
}
export function isFovGroup(fov) {
    return FovGroupTypes.includes(fov.nodeType);
}
export function hasTextSeenCondition(segment) {
    const fovFields = getFovs(segment);
    return fovFields.some(v => {
        var _a, _b;
        return (v.field === FovFieldTypes.GoalReference &&
            ((_b = (_a = v.value.page) === null || _a === void 0 ? void 0 : _a.children) === null || _b === void 0 ? void 0 : _b.some((y) => y.field === FovFieldTypes.FullText)));
    });
}
export function hasSamePageViewTextSeen(segment) {
    const builder = new FovBuilder(segment);
    return builder
        .conditions()
        .filter(v => v.field === FovFieldTypes.Pageviews)
        .some(condition => {
        var _a, _b, _c;
        const pvlBuilder = new FovBuilder(condition.value);
        const pvlConditions = pvlBuilder.conditions();
        const length = (_c = (_b = (_a = pvlConditions[0]) === null || _a === void 0 ? void 0 : _a.textConditions) === null || _b === void 0 ? void 0 : _b.children) === null || _c === void 0 ? void 0 : _c.length;
        return length > 0;
    });
}
export function getFovs(fov) {
    if (fov.nodeType === FovNodeTypes.FILTER) {
        return [fov];
    }
    if (fov.nodeType === FovNodeTypes.NOT) {
        return getFovs(fov.child);
    }
    if (!fov.children) {
        return [];
    }
    return fov.children.reduce((ret, item) => [...ret, ...getFovs(item)], []);
}
//# sourceMappingURL=fov-functions.js.map